import axios from "axios";
import { ElMessage } from 'element-plus';
import {Md5} from 'ts-md5';


//创建 http 实例
const $http = axios.create({
    baseURL:process.env.VUE_APP_BASE_API,
    //baseURL:'http://localhost:20100',
    timeout:600000,
    //processData:false,
    headers:{
        "Content-Type":"application/json;charset=utf-8"
    }
})

//请求拦截
$http.interceptors.request.use(config=>{
    config.headers = config.headers || {};
    let requestData = {} ;
    if(config.data){
        requestData = config.data ;
    }
    const entries = Object.entries(requestData);
    //处理URL携带的URL参数
    if(config.url!=null && config.url.indexOf('?')>-1){
        const urlParams = config.url?.slice(config.url.indexOf('?'))
        new URLSearchParams(urlParams).forEach((v,k)=>{
            if(k){
                entries.push([k,v]);
            }
        });
    }
    //将参数按字符大小顺序，生成MD5
    const keys:string[] = [];
    for(let i=0;i<entries.length;i++){
        const key = entries[i][0];
        if(key =="appkey" || key =="token"){
            continue;
        }
        keys.push(key)
    }
    const keysSorted = keys.sort(function(a, b) {  
        return a.toLowerCase().localeCompare(b.toLowerCase());  
    }); //排序后的键

    const appsecret = process.env.VUE_APP_APPSECRET;
    let token = "";
    for(let i=0;i<keysSorted.length;i++){
        const key:string = keysSorted[i];
        for(let j=0;j<entries.length;j++){
            if(entries[j][0]==key){
                token = `${token}${entries[j][1]}`;
            }
        }
    }
    token = `${token}${appsecret}`;
    const md5 = new Md5();   
    md5.appendStr(token);
    const tokenMd5:string =  md5.end() as string;
    config.headers.token = tokenMd5;
    config.headers.appkey = process.env.VUE_APP_APPKEY;
    const userInfoJson = window.localStorage.getItem("userInfo");
    if(userInfoJson){
        config.headers.frontEndUserID =  JSON.parse(userInfoJson).ID;
    }
    const lanType=window.localStorage.getItem('lanType');
    if(lanType){
        config.headers.lanType=lanType
    }
    const domainName=window.localStorage.getItem("domainName");
    if(domainName){
        config.headers.domainName=domainName;
    }
    const nationalRegion = window.localStorage.getItem("nationalRegion");
    if(nationalRegion){
        config.headers.nationalRegion=nationalRegion;
    }
    if(config.url!=null){
        const baseParam = {
            token:tokenMd5,
            appkey:process.env.VUE_APP_APPKEY,
            frontEndUserID:'',
            lanType:lanType,
            domainName:domainName
        }
        if(userInfoJson){
            baseParam.frontEndUserID = JSON.parse(userInfoJson).ID;
        }
        const baseParamStr = encodeURIComponent(JSON.stringify(baseParam));
        if(config.url.indexOf('?')>-1){
            config.url = `${config.url}&baseParam=${baseParamStr}`
        }else{
            config.url = `${config.url}?baseParam=${baseParamStr}`
        }
    }
    return config;
});

$http.interceptors.response.use(res=>{
    const code:number = res.data.code;
    if(code!=200){
        ElMessage.error(res.data.info);
        return Promise.reject(res.data)
    }
    return res.data;
},()=>{
    ElMessage.error("网络请求发送错误");
})

export default $http